// Accessibility display preference (high contrast).
// Stored in localStorage and applied as data attributes on <html> so the
// CSS overrides in index.css work on every page, independent of whether
// the AccessibilityWidget button is rendered on the current route.

export const CONTRAST_KEY = 'ba-high-contrast';

export const applyContrast = (on) => {
  if (on) {
    document.documentElement.setAttribute('data-contrast', 'high');
  } else {
    document.documentElement.removeAttribute('data-contrast');
  }
};


export const readPrefs = () => {
  const storedContrast = localStorage.getItem(CONTRAST_KEY);
  const contrastOn =
    storedContrast !== null
      ? storedContrast === '1'
      : window.matchMedia('(prefers-contrast: more)').matches;
  return { contrastOn };
};

export const setContrastPref = (on) => {
  applyContrast(on);
  localStorage.setItem(CONTRAST_KEY, on ? '1' : '0');
};


// Apply the saved preference on app start (called from App on every page load).
export const initA11yPrefs = () => {
  const prefs = readPrefs();
  applyContrast(prefs.contrastOn);
  return prefs;
};
